import { ExternalLink } from '@portal_components/components/ExternalLink';
import { Title } from '@portal_components/components/Title';

export const _404 = () => {
  return (
    <div id="contract-404">
      <div className="ml-10">
        <Title className="mt-7 mb-5" text="Page not found" />
        <p className="mb-2">We're sorry, the resource you're looking for cannot be found.</p>
        <p className="inline-block mr-1">Why not try</p>
        <ExternalLink className="inline-block" link="/" linkText="searching for your site" />
      </div>
    </div>
  );
};
